<template>

	<button class="button button-icon white" @click="setNextOption">
		<font-icon :icon="currentOption.icon" />
	</button>

</template>

<style scoped>

.button {
}

</style>

<script>

export default {
	props:['value'],
	data(){
		return {
			handler:'',
			options:[
				{value:'left', icon:'align-left'},
				{value:'center', icon:'align-center'},
				{value:'right', icon:'align-right'},
				{value:'justify', icon:'align-justify'},
			]
		}
	},
	computed:{
		currentOption(){
			return this.options.find(item=>item.value==this.handler) || this.options[0];
		}
	},
	methods:{
		setNextOption(){
			var currentIndex = this.options.indexOf(this.currentOption);
			var nextIndex = currentIndex + 1
			if(!this.options[nextIndex]) nextIndex=0;
			this.input(this.options[nextIndex].value);
		},
		input(newVal){
			this.handler = newVal;
			this.$emit('input',newVal)
		}
	},
	mounted(){
		this.handler = this.value || 'left';
	},

}
</script>